import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as resultCodes from "../constants/resultCodes";
import * as componentTypes from "../constants/componentTypes";
import * as rcc from "../constants/rcc";
import * as handlers from "../constants/handlers";
import * as statsTypes from "../constants/statsTypes";
import * as matchingActions from "../actions/matchingActions";
import * as navigationActions from "../actions/navigationActions";
import * as messageHelper from "../helpers/messageHelper";
import * as modelHelper from "../helpers/modelHelper";
import * as formatHelper from "../helpers/formatHelper";
import * as getterHelper from "../helpers/getterHelper";
import * as reducerHelper from "../helpers/reducerHelper";
import * as windowService from "../services/windowService";

export const processWebsocketAsyncResponse = (tabId, event, response, state, next) => {
    switch (event) {
        case methods.MACHINE_EVENT_CONNECT_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === false) {
                return [
                    {
                        type: actionTypes.MACHINE_SET_CONNECTION,
                        payload: {
                            connected: false
                        }
                    },
                    {
                        type: actionTypes.MACHINE_INITIALIZED
                    }
                ];
            }

            return [
                {
                    type: actionTypes.MACHINE_SET_CONNECTION,
                    payload: {
                        connected: true
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_CALLS
                    },
                    method: handlers.MACHINE_GET_CALLS,
                    tabId: 0,
                    safe: false
                }
            ];
        case methods.MACHINE_EVENT_INITIALIZE_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_RESET_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_HARD_RESET_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_DISCONNECT_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (
                state.machine.reconnectMachine &&
                state.rcc.defaultDriverConfiguration !== null &&
                state.rcc.defaultDriverConfiguration.type !== rcc.DRIVER_TYPE_NONE
            ) {
                return [
                    {
                        type: actionTypes.MACHINE_SET_CONNECTION,
                        payload: {
                            connected: false
                        }
                    },
                    {
                        type: actionTypes.MACHINE_SAVE_DRIVER_RECONNECT,
                        payload: {
                            reconnectMachine: false
                        }
                    },
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_START_CONNECT
                        },
                        method: handlers.MACHINE_START_CONNECT,
                        tabId: 0,
                        safe: false
                    }
                ];
            }

            return [
                {
                    type: actionTypes.MACHINE_SET_CONNECTION,
                    payload: {
                        connected: false
                    }
                }
            ];
        case methods.PRINTER_EVENT_JPG_EXPORT_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            window.imageStore.addPrintImage(
                next === null ? "preview" : next,
                response.data === undefined ? null : {type: "jpeg", img: response.data}
            );

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case methods.PRINTER_EVENT_PDF_EXPORT_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            windowService.openSaveDialog(response.data, formatHelper.formatFileName("PDF", "pdf"));

            return [];
        case methods.MACHINE_EVENT_ERRORS_RESET_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_GET_ERRORS
                        },
                        method: handlers.MACHINE_GET_ERRORS,
                        tabId: 0,
                        safe: false
                    }
                ];
            }
            return [];
        case methods.MACHINE_EVENT_DISPENSE_FORMULA_DONE:
            let dispensingDoneRequest = [
                {
                    type: actionTypes.UPDATE_DISPENSING_INFO,
                    payload: {
                        tabId: response.meta.tabId,
                        numCanDone: response.result === resultCodes.RCC_RESULT_OK ? 0 : null,
                        numCanTotal: null,
                        dispensing: false
                    }
                },
                {
                    type: actionTypes.POP_DISPENSING_FORMULA
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTERS
                    },
                    method: handlers.MACHINE_CANISTERS,
                    tabId: 0,
                    safe: false
                }
            ];

            if (response.meta.quickTint) {
                dispensingDoneRequest.push({
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.DISPENSING_QUICK_TINT_MODAL
                    }
                });
            }

            if (response.result === resultCodes.RCC_RESULT_OK) {
                const tabType = reducerHelper.getTabTypeById(state.navigation.tabList, response.meta.tabId);

                if (state.module.redlikeSoftware && getterHelper.isFormulaTab(tabType) && state.settings.autoCloseTab) {
                    dispensingDoneRequest.push(
                        navigationActions.closeActiveTab(response.meta.tabId, state.navigation.tabList, null)
                    );
                } else if (tabType === componentTypes.MATCHING_TAB && state.rcc.dispensingFormula !== null) {
                    if (
                        state.customTab[response.meta.tabId] === undefined &&
                        (state.rcc.dispensingFormula.formula.isCorrection() ||
                            state.rcc.dispensingFormula.formula.statsType === statsTypes.REFORMULATION)
                    ) {
                        dispensingDoneRequest.push(
                            navigationActions.closeActiveTab(response.meta.tabId, state.navigation.tabList, null)
                        );
                    } else {
                        dispensingDoneRequest.push(
                            matchingActions.setDraftFormulaScene(
                                response.meta.tabId,
                                state.rcc.dispensingFormula.formula.color.rgb
                            )
                        );
                    }
                } else {
                    dispensingDoneRequest.push({
                        type: actionTypes.SAVE_FORMULA_STATISTICS_ID,
                        payload: {
                            tabId: tabId,
                            colorStatsId: null
                        }
                    });
                }
            }

            let statisticsTab = state.navigation.tabList.find((tab) => tab.type === componentTypes.STATISTICS_TAB);
            if (statisticsTab) {
                dispensingDoneRequest.push({
                    type: actionTypes.STATISTICS_LIST_UPDATE,
                    payload: {
                        tabId: statisticsTab.id
                    }
                });
            }

            if (response.result !== resultCodes.RCC_RESULT_OK) {
                let toDispenseTab = state.navigation.tabList.find((tab) => tab.type === componentTypes.TO_DISPENSE_TAB);

                dispensingDoneRequest.push(messageHelper.getRccFlashMessage(response));
                dispensingDoneRequest.push(
                    {
                        type: actionTypes.TO_DISPENSE_LIST_UPDATE,
                        payload: {
                            tabId: toDispenseTab ? toDispenseTab.id : 0
                        }
                    },
                    {
                        type: actionTypes.ORDERS_HISTORY_LIST_UPDATE,
                        payload: {
                            tabId: 0
                        }
                    }
                );
            }

            if (!state.module.redlikeLightSoftware) {
                return dispensingDoneRequest;
            }

            if (
                state.navigation.activeTabScene === componentTypes.SUMMARY_SCENE &&
                state.formula[tabId] !== undefined &&
                state.formula[tabId].statisticsId === response.meta.colorStatsId
            ) {
                if (response.result === resultCodes.RCC_RESULT_OK) {
                    dispensingDoneRequest.push(
                        {
                            type: actionTypes.CLOSE_ACTIVE_TAB,
                            payload: {
                                newActive: componentTypes.DEFAULT_TAB_ID,
                                newTabList: state.navigation.tabList.filter((tab) => tab.id !== tabId)
                            }
                        },
                        {
                            type: actionTypes.OPEN_HOME_TAB
                        }
                    );
                }
            }

            if (
                state.navigation.activeTabType === componentTypes.TO_DISPENSE_TAB &&
                state.navigation.activeTabScene === componentTypes.DETAIL_SCENE &&
                (state.toDispense.activeOrder === null || state.toDispense.activeOrder.id === response.meta.orderId)
            ) {
                dispensingDoneRequest.push({
                    type: actionTypes.SET_ACTIVE_TAB_SCENE,
                    payload: {
                        tabId: tabId,
                        scene: componentTypes.TABLE_SCENE
                    }
                });
            }

            return dispensingDoneRequest;
        case methods.MACHINE_EVENT_MOVE_TABLE_TO_REFILL_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_SHELF_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_PUNCH_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_PLUG_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_CAP_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_SERVICE_WINDOW_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [
                    messageHelper.getRccFlashMessage(response),
                    {
                        type: actionTypes.SET_BLOCKED_UI,
                        payload: {
                            blocked: false
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SET_BLOCKED_UI,
                    payload: {
                        blocked: false
                    }
                }
            ];
        case methods.MACHINE_EVENT_CLEAN_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_CLEAN_ALL_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_RECIRCULATE_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_RECIRCULATE_ALL_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_STIR_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_STIR_ALL_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case methods.MACHINE_EVENT_SMART_PURGE_DONE:
        case methods.MACHINE_EVENT_PURGE_DONE:
            if (
                response.result !== resultCodes.RCC_RESULT_OK &&
                response.result !== resultCodes.RCC_RESULT_FORMULA_COLORANT_MISSING
            ) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            let dateFrom = state.filtering[componentTypes.MODAL_SETTINGS_TAB]
                ? state.filtering[componentTypes.MODAL_SETTINGS_TAB].dateFrom
                : null;
            let dateTo = state.filtering[componentTypes.MODAL_SETTINGS_TAB]
                ? state.filtering[componentTypes.MODAL_SETTINGS_TAB].dateTo
                : null;

            return [
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTERS
                    },
                    method: handlers.MACHINE_CANISTERS,
                    tabId: 0,
                    safe: false
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_PURGE_STATS,
                        params: {
                            startDate: dateFrom !== null ? formatHelper.formatDateTimeForServer(dateFrom) : null,
                            endDate: dateTo !== null ? formatHelper.formatDateTimeForServer(dateTo) : null
                        }
                    },
                    method: handlers.MACHINE_GET_PURGE_STATS,
                    tabId: 0,
                    safe: true
                }
            ];
        case methods.MACHINE_EVENT_SMART_PURGE_ALL_DONE:
        case methods.MACHINE_EVENT_PURGE_ALL_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            let dateFromAll = state.filtering[componentTypes.MODAL_SETTINGS_TAB]
                ? state.filtering[componentTypes.MODAL_SETTINGS_TAB].dateFromAll
                : null;
            let dateToAll = state.filtering[componentTypes.MODAL_SETTINGS_TAB]
                ? state.filtering[componentTypes.MODAL_SETTINGS_TAB].dateToAll
                : null;

            return [
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTERS
                    },
                    method: handlers.MACHINE_CANISTERS,
                    tabId: 0,
                    safe: false
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_PURGE_STATS,
                        params: {
                            startDate: dateFromAll !== null ? formatHelper.formatDateTimeForServer(dateFromAll) : null,
                            endDate: dateToAll !== null ? formatHelper.formatDateTimeForServer(dateToAll) : null
                        }
                    },
                    method: handlers.MACHINE_GET_PURGE_STATS,
                    tabId: 0,
                    safe: true
                }
            ];
        case methods.SPECTRO_EVENT_CONNECT_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.SPECTRO_SET_CONNECTION,
                        payload: {
                            connected: true
                        }
                    },
                    {
                        type: actionTypes.RCC_SPECTRO_REQUEST,
                        payload: {
                            type: methods.METHOD_SPECTRO_GET_CALLS
                        },
                        method: handlers.SPECTRO_GET_CALLS,
                        tabId: 0,
                        safe: false
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SPECTRO_SET_CONNECTION,
                    payload: {
                        connected: false
                    }
                }
            ];
        case methods.SPECTRO_EVENT_DISCONNECT_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SPECTRO_SET_CONNECTION,
                    payload: {
                        connected: false
                    }
                }
            ];
        case methods.SPECTRO_EVENT_CALIBRATE_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.SAVE_SPECTRO_CALIBRATED,
                        payload: {
                            calibrated: true
                        }
                    }
                ];
            }

            return [];
        case methods.SPECTRO_EVENT_MEASURE_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK || response.data === undefined) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: next === null ? actionTypes.SAVE_SPECTRO_MEASURE_RESULT : next,
                    payload: {
                        tabId: tabId,
                        result: modelHelper.mapSpectralData(response.data)
                    }
                },
                {
                    type: actionTypes.RCC_SPECTRO_REQUEST,
                    payload: {
                        type: methods.METHOD_SPECTRO_IS_CALIBRATED
                    },
                    method: handlers.SPECTRO_IS_CALIBRATED,
                    tabId: tabId,
                    safe: false
                }
            ];
        case methods.MACHINE_EVENT_AUTOTASK_DONE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_RCC_ACTION
                }
            ];
    }
};
